<h1 style="color:#e7bd42">Il nostro team</h1>

<div class="layout horizontal center middle" style="margin: 0px 60px;color: white; flex-wrap: wrap;">
    <div class="box layout vertical center top" style="margin-bottom: 20px;" [ngStyle]="{'height': widthInPx >= 1170 ? '1200px' : null}">
        <!-- <img [attr.src]="src$ | async" style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '420'"> -->
        <!-- <img *ngIf="afterInit" [attr.src]="src$ | async" style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '420'">
        <img *ngIf="!afterInit" src="assets/images/team2.jpeg" style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '420'"> -->
        <img src="assets/images/team.jpg" style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '500'">
       <div style="position: relative;"
             [ngStyle]="{'width': isXxxs ? '340px' : '500px','height':'100%'}">
            <!-- <div class="layout horizontal center top" style="height: 40px; font-size: 26px; position: absolute; left: 0; right: 0; top: -30px;">
                <span style="border-radius: 15px 15px; background-color: #e7bd42; padding: 10px 16px 4px 16px;"><b>Enzo Raco</b></span>
            </div> -->
            <div class="layout horizontal center top" style="padding: 30px 20px 0 20px; height: 100%;">

                 <div class="layout vertical center top" style="height: 100%;" [ngStyle]="{'font-size': isXxxs ? '18px' : '22px'}">
                    <b>Performance Training Lab ti aspetta con il suo staff per costruire insieme un percorso di allenamento su misura per te</b>

                    <div class="layout vertical center middle" style="height: 100%; padding: 10px 0 20px 0;">
                        <app-button [label]="isXxxs ? 'PROVA!' : 'CORAGGIO: FISSA LA TUA PROVA!'" primary="true" 
                        (click)="contactUsClick()"
                        [settings]="{padding: !isMobile ? '8px 50px' : '8px',bgColor:'#43aae0'}"></app-button>
                    </div>
                 </div>
                
            </div>
        </div>
    </div>
    <div class="box layout vertical center top" style="margin-bottom: 20px;" [ngStyle]="{'height': widthInPx >= 1170 ? '1200px' : null}">
        <img src="assets/images/team-vincenzo.jpg"  style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '500'">
        <div style="position: relative;"
             [ngStyle]="{'width': isXxxs ? '340px' : '500px'}">
            <div class="layout horizontal center top" style="height: 40px; font-size: 26px; position: absolute; left: 0; right: 0; top: -30px">
                <span *ngIf="!isXxxs" style="border-radius: 15px 15px; background-color: #e7bd42; padding: 10px 16px 4px 16px;"><b>Vincenzo Pierpaolo Franco</b></span>
                <span *ngIf="isXxxs" style="border-radius: 15px 15px; background-color: #e7bd42; padding: 10px 16px 4px 16px;"><b>Vincenzo P. Franco</b></span>
            </div>
            <div class="layout horizontal center top" style="height: 70px; margin-top: 30px; padding: 0 10px"
                 [ngStyle]="{'font-size': isXxxs ? '16px' : '20px'}">
                <b><i>"Non esiste un solo modo per raggiungere l’obbiettivo: lavorare insieme per trovare la strada giusta per te!"</i></b>
            </div>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Specialità</div>
            <ul>
                <li style="color:white">Preparazione atletica calcio
                <li style="color:white">Rieducazione post infotunio
                <li style="color:white">Allenamento posturale
                <li style="color:white">Ipertrofia
                <li style="color:white">Dimagrimento
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Esperienze</div>
            <ul>
                <li style="color:white">Preparazione atletica calcio serie A
                <li style="color:white">Recupero atleti infortunati
                <li style="color:white">Personal trainer
                <li style="color:white">Massaggiatore sportivo
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Formazione</div>
            <ul>
                <li style="color:white">Laurea scienze motorie e sportive
                <li style="color:white">Preparatore atletico F.I.G.C.
                <li style="color:white">Master livello I in osteopatia
                <li style="color:white">Corso Dream K taping neuro muscolare
            </ul>
        </div>
    </div>
    <div class="box layout vertical center top" style="margin-bottom: 20px;" [ngStyle]="{'height': widthInPx >= 1170 ? '1200px' : null}">
        <img src="assets/images/team-jacopo.jpg"  style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '500'">
        <div style="position: relative;"
             [ngStyle]="{'width': isXxxs ? '340px' : '500px'}">
            <div class="layout horizontal center top" style="height: 40px; font-size: 26px; position: absolute; left: 0; right: 0; top: -30px">
                <span style="border-radius: 15px 15px; background-color: #e7bd42; padding: 10px 16px 4px 16px;"><b>Jacopo Rivarossa</b></span>
            </div>
            <div class="layout horizontal center top" style="height: 70px; margin-top: 30px; padding: 0 10px"
                 [ngStyle]="{'font-size': isXxxs ? '16px' : '20px'}">
                <b><i>"Allenare corpo e mente con l’energia di chi ha tutto da dimostrare"</i></b>
            </div>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Specialità</div>
            <ul>
                <li style="color:white">Performance sportiva
                <li style="color:white">Allenamento forza
                <li style="color:white">Functional Training
                <li style="color:white">Dimagrimento e tonificazione
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Esperienze</div>
            <ul>
                <li style="color:white">Preparazione atletica calcio
                <li style="color:white">Personal trainer 
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Formazione</div>
            <ul>
                <li style="color:white">Laurea scienze motorie e sportive
                <li style="color:white">Laurea magistrale in scienze e tecniche avanzate dello sport
            </ul>
        </div>
    </div>
    <div class="box layout vertical center top" style="margin-bottom: 20px;" [ngStyle]="{'height': widthInPx >= 1170 ? '1200px' : null}">
        <img src="assets/images/team-michele.jpg"  style="border-radius: 13px 48px 0 0;" [width]="isXxxs ? '340' : '500'">
        <div style="position: relative;"
             [ngStyle]="{'width': isXxxs ? '340px' : '500px'}">
            <div class="layout horizontal center top" style="height: 40px; font-size: 26px; position: absolute; left: 0; right: 0; top: -30px">
                <span style="border-radius: 15px 15px; background-color: #e7bd42; padding: 10px 16px 4px 16px;"><b>Michele Morra</b></span>
            </div>
            <div class="layout horizontal center top" style="height: 70px; margin-top: 30px; padding: 0 10px"
                 [ngStyle]="{'font-size': isXxxs ? '16px' : '20px'}">
                <b><i>"La chiave di tutto è la costanza e la determinazione senza dimenticare il sorriso in tasca SEMPRE!"</i></b>
            </div>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Specialità</div>
            <ul>
                <li style="color:white">Personal training one to one e Mental Coach
                <li style="color:white">Rieducazione e riatletizzazione infortuni/patologie schiena e ginocchia e recupero neuromotorio
                <li style="color:white">Performance analyst con cardiofrequenzimetri Polar
                <li style="color:white">Preparatore atletico tennis, golf, calcio, volley
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Esperienze</div>
            <ul>
                <li style="color:white">Professional Volleyball player da 1996 al 2004
                <li style="color:white">Preparatore atletico A.C Milan dal 2006 al 2009
                <li style="color:white">Consulente programmazione preparazione atletico sportiva nello sport professionistico dal 2010
                <li style="color:white">Personal Trainer “Fitness First” dal 2004 al 2018
                <li style="color:white">Chinesiologo
            </ul>
            <div style="color:white; padding-left: 10px; padding-top: 10px">Formazione</div>
            <ul>
                <li style="color:white">Laurea Scienze Motorie e Sportive presso S.U.I.S.M di Torino
                <li style="color:white">Laurea Scienze Motorie e Sportive e Managment dello sport presso S.U.I.S.M di Torino
            </ul>
        </div>
    </div>
</div>